// https://surajsharma.net/blog/react-material-ui-create-custom-theme
// https://zenoo.github.io/mui-theme-creator/

import { createTheme } from '@mui/material/styles'

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#002b5c',
            light: '#002b5c',
            dark: '#002b5c',
            contrastText: '#FFFFFF'
        },
        secondary: {
            main: '#343A40',
            light: '#5C6166',
            dark: '#24282C',
            contrastText: '#C8C8C8'
        },
        error: {
            main: '#E31B23',
            light: '#E8484F',
            dark: '#9E1218'
        },
        warning: {
            main: '#FFC107',
            light: '#FFCD38',
            dark: '#B28704'
        },
        info: {
            main: '#17A2B8',
            light: '#45B4C6',
            dark: '#107180'
        },
        success: {
            main: '#009D57',
            light: '#33B078',
            dark: '#006D3C'
        },
        grey: {
            100: '#F6F6FA',
            200: '#EDEDF5',
            300: '#EDEDF5',
            400: '#BBBBC7',
            500: '#9595A2',
            600: '#DCDCDC', // "#727286",
            700: '#A2A2A2', // "#727286",
            800: '#373747',
            900: '#232330'
        }
    },
    typography: {
        fontFamily: "Calibri, 'Calibri Regular', sans-serif",
        htmlFontSize: 16,
        fontSize: 14,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 900,
        h1: {
            fontWeight: 700,
            fontSize: '1.75rem'
        },
        h2: {
            fontWeight: 700,
            fontSize: '1.625rem'
        },
        h3: {
            fontWeight: 700,
            fontSize: '1.375rem'
        },
        h4: {
            fontWeight: 700,
            fontSize: '1.25rem'
        },
        h5: {
            fontWeight: 700,
            fontSize: '1.125rem'
        },
        h6: {
            fontWeight: 700,
            fontSize: '1rem'
        },
        subtitle1: {
            fontWeight: 500,
            fontSize: '0.875rem'
        },
        subtitle2: {
            fontWeight: 700,
            fontSize: '0.875rem'
        },
        body1: {
            fontWeight: 500,
            fontSize: '1rem'
        },
        body2: {
            fontWeight: 500,
            fontSize: '0.875rem'
        },
        button: {
            fontWeight: 700,
            fontSize: '0.75rem'
        }
    }
});

export default theme;
